/**
 * organization — 기관 Master 전용 메뉴 상태 (바우처 기관발행)
 * · 로그인 직후 GET /voucher/org/me 로 "내가 Master 인 기관" 목록을 받는다. 0건·오류면 메뉴를 숨긴다.
 * · 기관이 여러 개면 화면 상단 셀렉터로 고른다. 선택은 localStorage 에 남겨 새로고침 뒤에도 유지한다.
 * 정본: docs/바우처_기관발행_강사화면.md §2·§3.1
 */
import axios from "axios";
import CONF from "@/Config.js";

const LS_KEY = "pineapple.organizationIdx";

const readSavedIdx = () => {
  const v = localStorage.getItem(LS_KEY);
  return v ? Number(v) : null;
};

const state = {
  organizations: [], // [{ organization_idx, name, name_en, voucher_currency, voucher_balance, voucher_discount_rate }]
  loaded: false,
  currentIdx: readSavedIdx(),
};

const getters = {
  isMaster: (s) => s.organizations.length > 0,
  organizations: (s) => s.organizations,
  loaded: (s) => s.loaded,
  current: (s) =>
    s.organizations.find((o) => o.organization_idx === s.currentIdx) || s.organizations[0] || null,
  currentIdx: (s, g) => (g.current ? g.current.organization_idx : null),
};

const mutations = {
  SET_ORGANIZATIONS(state, list) {
    state.organizations = Array.isArray(list) ? list : [];
    state.loaded = true;
    // 저장된 선택이 목록에 없으면 첫 기관으로
    if (!state.organizations.some((o) => o.organization_idx === state.currentIdx)) {
      state.currentIdx = state.organizations[0] ? state.organizations[0].organization_idx : null;
    }
  },
  SET_CURRENT(state, idx) {
    state.currentIdx = idx;
    if (idx == null) localStorage.removeItem(LS_KEY);
    else localStorage.setItem(LS_KEY, String(idx));
  },
  RESET(state) {
    state.organizations = [];
    state.loaded = false;
  },
};

const fetchMine = async () => {
  const token = localStorage.getItem("access_token");
  if (!token || token === "null") return [];
  const res = await axios.get(`${CONF.API_URL}/voucher/org/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(res.data) ? res.data : [];
};

const actions = {
  /** 로그인 부팅 경로에서 호출. 실패해도 로그인에는 영향을 주지 않는다(메뉴만 숨김). */
  async load({ commit }) {
    try {
      const list = await fetchMine();
      commit("SET_ORGANIZATIONS", list);
      return list;
    } catch (e) {
      commit("SET_ORGANIZATIONS", []);
      return [];
    }
  },
  /** 화면 진입 시 잔액 등 최신화. 일시 오류로 메뉴가 사라지지 않게 비어 있지 않을 때만 반영한다. */
  async refresh({ commit }) {
    try {
      const list = await fetchMine();
      if (list.length) commit("SET_ORGANIZATIONS", list);
      return list;
    } catch (e) {
      return null;
    }
  },
  select({ commit }, idx) {
    commit("SET_CURRENT", idx == null ? null : Number(idx));
  },
  reset({ commit }) {
    commit("RESET");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
